import React from "react";
import moment, { invalid } from "moment";
import { Row, Col } from "antd";
import InputComponent from "./InputComponent";
import SelectComponent from "./SelectComponent";
import { SelectComponentWrap } from "./Tabs/styles";
import {
  MainWrapper,
  ErrMargin,
  MarginComponentDrop
} from "../styles";
import {
  LabelWrapper,
  RowWrapper
} from "../../Step1Setup/styles";
import DatePickerComponent from "./DatePicker";
import {
  filterSuffixData,
  filterRelationData,
  filterTitleData  
} from "../../../Components/Data/DropDownData";
import validate from "../../../../../utils/validations";
import regexMap from "../../../../../utils/regexMap";
import constants from "../../../constants";

export default class SuccessorInfo extends React.Component {
    constructor(props) {
        super(props);        
        this.state = {
        relation: {
            value: this.getRelationShipId(props.successorData),
            touched: false,
            valid: '',
            validationRules: {
            isRequired: true,
            },
            messages: {
            isRequired: "Please enter relationship to account advisor for successor to continue"
            }
        },
        firstName: {
            value: props.successorData.firstName || "",
            touched: false,
            valid: '',
            matchPattern: regexMap.name,
            validationRules: {
                isRequired: true,
                minLength: 2
            },
            messages: {
                isRequired: "Please enter first name for successor to continue.",
                minLength: "First name is to short. Please correct to proceed."
            }
        },
        middleName: {
            value: props.successorData.middleName || "",
            touched: false,
            valid: '',
            matchPattern: regexMap.name
        },
        lastName: {
            value: props.successorData.lastName || "",
            touched: false,
            valid: '',
            matchPattern: regexMap.name,
            validationRules: {
            isRequired: true,
            minLength: 2
            },
            messages: {
            isRequired: "Please enter last name for successor to continue.",
            minLength: "Last name is to short. Please correct to proceed."
            }
        },
        title: {
            value: this.getDropDownValueByDesc('title', props.successorData),
            touched: false,
            valid: '',
        },
        suffix: {
            value: this.getDropDownValueByDesc('suffix', props.successorData),
            touched: false,
            valid: '',
        },
        dob: {
            value: this.getDob(props.successorData),
            touched: false,
            valid: '',
        },
        dobStr: {
            value: props.successorData.dobStr || "",
            touched: false,
            valid: '',
            validationRules: {
                isRequired: true,
            },
            messages: {
                isRequired: "Please enter date of birth to continue."
            }
        },
        phone: {
            value: props.successorData.preferedPhone || "",
            touched: false,
            valid: '',
            
        },
        email: {
            value: props.successorData.preferedEmail || "",
            touched: false,
            valid: '',
            validationRules: {
                matchPattern: regexMap.email,
            },
            messages: {
                matchPattern: 'Invalid email format',
            }
        },
        };
    }

    getRelationShipId(successorData) {        
        if(successorData && successorData.relationshipType) {
            successorData.salesforceRelationshipTypeId = successorData.relationshipType;
            return successorData.relationshipType;
        }

        if(successorData && successorData.salesforceRelationshipTypeId) {
            successorData.relationshipType = successorData.salesforceRelationshipTypeId;
            return successorData.salesforceRelationshipTypeId;
        }                     
    }

    getDob(successorData) {        
        if(successorData && successorData.dobStr) {
            return new Date(successorData.dobStr).getTime();
        }

        if(successorData && successorData.dob) {
            return successorData.dob;
        }

        return '';
    }

    getDropDownValueByDesc(type, successorData) {
        const { titleDropDown, suffixDropDown  } = this.props;        
        if(type === "title") {
            if(successorData && successorData.title) {
                let title = titleDropDown.find(i => i.desc === successorData.title);
                if(title) {
                    return title.value;
                } else {
                    return successorData.title;
                }
            }
        }

        if(type === "suffix") {
            if(successorData && successorData.suffix) {
                let suffix = suffixDropDown.find(i => i.desc === successorData.suffix);
                if(suffix) {
                    return suffix.value;
                } else {
                    return successorData.suffix;
                }
            }
        }
        
        return '';
    }

    componentDidMount() {
        this.handleFormChange();
    }
    
    componentWillReceiveProps(props) {         
        this.setState({
            relation: {
                ...this.state.relation,
                value: this.getRelationShipId(props.successorData),
            },
            firstName: {
                ...this.state.firstName,
                value: props.successorData.firstName || "",
                
            },
            middleName: {
                ...this.state.middleName,
                value: props.successorData.middleName || ""
            },
            lastName: {
                ...this.state.lastName,
                value: props.successorData.lastName || "",
            },
            title: {
                value: this.getDropDownValueByDesc('title', props.successorData),
                touched: true,
                valid: '',
            },
            suffix: {
                value: this.getDropDownValueByDesc('suffix', props.successorData),
                touched: true,
                valid: '',
            },
            dob: {
                ...this.state.dob,
                value: this.getDob(props.successorData),
            },
            dobStr: {
                ...this.state.dobStr,
                value: props.successorData.dobStr || "",
            },
            phone: {
                value: props.successorData.preferedPhone || "",
                touched: true,
                valid: '',  
            },
            email: {
                ...this.state.email,
                value: props.successorData.preferedEmail || "",
            },
            },()=>{
                if(props.validateForm){
                    this.runFormValidation();
                }
            });
        
    }
   
    componentDidUpdate(prevProps){

        if(this.props.legacyFormValid && prevProps.legacyFormValid !== this.props.legacyFormValid ){
            const updatedFormElement = {
                ...this.state
            };
            for (const inputIdentifier of Object.keys(updatedFormElement)) {
                if (updatedFormElement[inputIdentifier].validationRules 
                    && Object.keys(updatedFormElement[inputIdentifier].validationRules).length) {
                        updatedFormElement[inputIdentifier].touched = false;
                    }
            }
            this.setState({
                ...updatedFormElement
            });
        }
        
    }
    runFormValidation = () => {
        const updatedFormElement = {
            ...this.state
        };
        for (const inputIdentifier of Object.keys(updatedFormElement)) {
            if (updatedFormElement[inputIdentifier].validationRules 
                && Object.keys(updatedFormElement[inputIdentifier].validationRules).length) {
                    updatedFormElement[inputIdentifier].valid = validate(updatedFormElement[inputIdentifier].value, updatedFormElement[inputIdentifier].validationRules);
                    updatedFormElement[inputIdentifier].touched = true;
                }
        }
        this.setState({
            ...updatedFormElement
        });
    }

    handleBlur = (event, field = '') => {

        let name = '', value = '';
        if(field) {
            name = field;
        } else {
            name = event ? event.target.name: '';
        }
        const updatedFormElement = {
            ...this.state[name]
        };

        if(field === 'relation') {
            value = event;
        {/* MSP-1329 Birthdate displaying incorrectly to donor on DP */}
        } else if(field === 'dobStr') {                  
            value = updatedFormElement.value;
        } else {         
            value = event && event.target ? event.target.value: '';
        }

        updatedFormElement.valid = validate(value, updatedFormElement.validationRules);
        updatedFormElement.touched = true;
        this.setState((prevState)=>{
            if(prevState[name].valid !== updatedFormElement.valid){
                return {
                    [name] : updatedFormElement
                }
            }
        })        
    };

    handleInputChange = (event) => {
        const name = event.target.name;
        const value = event.target.value;        
        const updatedFormElement = {
            ...this.state[name]
        };
        
        const matched = updatedFormElement.matchPattern ? updatedFormElement.matchPattern.test(value) : true;
        if (matched) {
            updatedFormElement.value = value;
            updatedFormElement.touched = true;
            updatedFormElement.valid = "";
            this.setState({
                [name]: updatedFormElement
            }, this.handleFormChange);
        }
    };

    handleSelectChange = (value, targetName, options) => {
        const name = targetName;        
        const updatedFormElement = {
            ...this.state[name]
        };
        
        const matched = options.filter(el => value === el.value);
        if (matched.length) {
            updatedFormElement.value = matched[0].value;
            updatedFormElement.touched = true;
            updatedFormElement.valid = "";
            this.setState({
                [name]: updatedFormElement
            }, this.handleFormChange);
        }
    }

    handleDateChange = (value, name) => {
        const updatedFormElement = {
            ...this.state[name]
        };

        if(value==="Invalid date" || !value){
            updatedFormElement.value =undefined;
            updatedFormElement.touched = true; 
        }else{
            {/* MSP-1329 Birthdate displaying incorrectly to donor on DP */}
            updatedFormElement.value = moment(value).format('MM/DD/YYYY')
            updatedFormElement.touched = true;
            updatedFormElement.valid = "";
        }

        this.setState({
            [name]: updatedFormElement
        },  this.handleFormChange);
    }

    checkFormValid = (state) => {
        let formIsValid = true;
        for (let inputIdentifier of Object.keys(state)) {
            if (state[inputIdentifier].validationRules 
                && Object.keys(state[inputIdentifier].validationRules).length) {
                    formIsValid = !validate(state[inputIdentifier].value, state[inputIdentifier].validationRules) && formIsValid;
                }
        }
        return formIsValid;
    }

    handleFormChange = () => {
        this.props.handleFormChange(this.formatData(this.state));
    }

    formatData = (state) => {
        // MSP-1329, dobStr is used for validation purpose and setting in datepicker.
        // dob:- API requires milisecond time. hence dob is used.
        return {
            data: {
                dobStr: state.dobStr.value,
                dob: moment(state.dobStr.value).format("x"),
                firstName: state.firstName.value,
                lastName: state.lastName.value,
                middleName: state.middleName.value,
                preferedEmail: state.email.value,
                preferedPhone: state.phone.value,
                relationshipType: state.relation.value,
                suffix: state.suffix.value,
                title: state.title.value,
            },
            isFormValid: this.checkFormValid(state)
        };
    }

    showError = (elem) => {        
        return elem.touched && elem.valid;
    }

    render() {
        const { relation, firstName, middleName, lastName, title, suffix, dobStr, phone, email} = this.state;
        if (!this.props.relationshipDropDown || !this.props.suffixDropDown || !this.props.titleDropDown) {
            return null;
        }       
        return (
        <MainWrapper data-test="contentWrapper">
            <Row>
            <Col lg={{ span: 10}} md={{ span: 10 }}>            
                <SelectComponentWrap>
                <MarginComponentDrop>
                <SelectComponent
                    data-test="titleContent"
                    name="title"
                    className="form-select"
                    id={`title${this.props.successorKey}${this.props.contentKey}`}
                    title="Title (Optional)"
                    placeholder="Enter title"
                    data={this.props.titleDropDown}
                    showArrow={false}
                    handleInputChange={e =>
                    this.handleSelectChange(e, "title", this.props.titleDropDown)
                    }
                    value={
                    title.value && filterTitleData(
                            title.value,
                            this.props.titleDropDown
                        ).length ? filterTitleData(
                            title.value,
                            this.props.titleDropDown)[0].desc
                        : undefined
                    }
                />
                </MarginComponentDrop>
                </SelectComponentWrap>
            </Col>

            <Col lg={{ span: 10, offset: 1 }} md={{ span: 10 }}>
                <InputComponent
                name="firstName"
                id={`ELOFrstName${this.props.successorKey}${
                    this.props.contentKey
                }`}
                arialabel="Enter First Name"
                data-test="firstName"
                handleBlur={this.handleBlur}
                title="First Name"
                placeholder="Enter first name"
                handleInputChange={this.handleInputChange}
                value={firstName.value}
                max={150}
                />
                {this.showError(firstName) ? <ErrMargin>{firstName.messages[firstName.valid]}</ErrMargin> : null}
            </Col>
            </Row>
            <Row>
            <Col lg={{ span: 10, offset: 0 }} md={{ span: 10 }}>
                <InputComponent
                data-test="middleName"
                id={`ELOMdlName${this.props.successorKey}${
                    this.props.contentKey
                }`}
                name="middleName"
                arialabel="Enter middle Name"
                title="Middle Name (Optional)"
                placeholder="Enter middle name"
                handleInputChange={this.handleInputChange}
                value={middleName.value}
                max={150}
                />
            </Col>

            <Col lg={{ span: 10, offset: 1 }} md={{ span: 10 }}>
                <InputComponent
                data-test="lastName"
                name="lastName"
                id={`ELOLastName${this.props.successorKey}${
                    this.props.contentKey
                }`}
                title="Last Name"
                arialabel="Enter last Name"
                placeholder="Enter last name"
                handleBlur={this.handleBlur}
                handleInputChange={this.handleInputChange}
                value={lastName.value}
                max={150}
                />
                {this.showError(lastName) ? <ErrMargin>{lastName.messages[lastName.valid]}</ErrMargin> : null}
            </Col>
            </Row>
            <Row>
            <Col lg={{ span: 10, offset: 0 }} md={{ span: 10 }}>
                <SelectComponentWrap>
                <MarginComponentDrop>
                    <SelectComponent
                    data-test="selSuffix"
                    name="suffix"
                    className="form-select"
                    id={`suffix${this.props.successorKey}${
                        this.props.contentKey
                    }`}
                    title="Suffix (Optional)"
                    placeholder="Enter suffix"
                    arialabel="Select suffix"
                    data={this.props.suffixDropDown}
                    showArrow={false}
                    handleInputChange={e =>
                        this.handleSelectChange(e, "suffix", this.props.suffixDropDown)
                    }
                    value={
                        suffix.value && filterSuffixData(
                            suffix.value,
                            this.props.suffixDropDown
                            ).length
                        ? filterSuffixData(
                            suffix.value,
                            this.props.suffixDropDown
                            )[0].desc
                        : undefined
                    }
                    />
                </MarginComponentDrop>
                </SelectComponentWrap>
            </Col>
            <Col lg={{ span: 10, offset: 1 }} md={{ span: 10 }}>
                <SelectComponentWrap>
                <MarginComponentDrop>
                <SelectComponent
                    data-test="selRelation"
                    className="form-select"
                    name="relation"
                    handleBlur={e => this.handleBlur(e, "relation")}
                    id={`relation${this.props.successorKey}${
                    this.props.contentKey
                    }`}
                    title="Relation"
                    arialabel="Select Relationship"
                    placeholder="-Select-"
                    data={this.props.relationshipDropDown}
                    showArrow={true}
                    handleInputChange={e =>
                    this.handleSelectChange(e, "relation", this.props.relationshipDropDown)
                    }
                    tabKey={this.props.successorKey - 1}
                    optionCard={this.props.contentKey}
                    value={
                    relation.value && filterRelationData(
                            relation.value,
                            this.props.relationshipDropDown
                        ).length ? filterRelationData(
                            relation.value,
                            this.props.relationshipDropDown
                        )[0].desc
                        : undefined
                    }
                />
                </MarginComponentDrop>
                </SelectComponentWrap>
                {this.showError(relation) ? <ErrMargin>{relation.messages[relation.valid]}</ErrMargin> : null}
            </Col>
            </Row>
            <Row>
            <Col lg={{ span: 10, offset: 0 }} md={{ span: 10 }}>
                {/* MSP-1329 Birthdate displaying incorrectly to donor on DP */}
                <DatePickerComponent
                    data-test="contentDatePicker"
                    id={`successorDob${this.props.optionId}${this.props.successorKey}`}
                    name="dobStr"
                    title="Date of Birth"
                    ariaLabel="Select date"
                    placeholder="Select date"
                    handleBlur={ e => this.handleBlur(e, 'dobStr') }
                    handleInputChange={e =>
                        this.handleDateChange(e, "dobStr")
                    }
                    value={
                        dobStr.value
                        ? moment(dobStr.value).format('MM/DD/YYYY')
                        : undefined
                    }
                />
               {this.showError(dobStr) ? <ErrMargin>{dobStr.messages[dobStr.valid]}</ErrMargin> : null}
            </Col>
            </Row>
            <RowWrapper>
            <LabelWrapper>Phone</LabelWrapper>
            </RowWrapper>
            <Row>
            <Col lg={{ span: 10 }} md={{ span: 10 }}>
                <InputComponent
                data-test="phoneNumber"
                arialabel="Enter Phone number"
                id={`ELOPhNo${this.props.successorKey}${
                    this.props.contentKey
                }`}
                name="phone"
                title="Phone Number (Optional)"
                placeholder="Enter number"
                handleInputChange={this.handleInputChange}
                handleBlur={this.handleBlur}
                value={phone.value}
                max={25}
                />
                {this.showError(phone) ? <ErrMargin>{phone.messages[phone.valid]}</ErrMargin> : null}
            </Col>
            </Row>
            <RowWrapper>
            <LabelWrapper>Email</LabelWrapper>
            </RowWrapper>
            <Row>
            <Col lg={{ span: 10 }} md={{ span: 10 }}>
                <InputComponent
                data-test="email"
                arialabel="Enter email"
                name="email"
                id={`ELOEmail${this.props.successorKey}${
                    this.props.contentKey
                }`}
                handleBlur={this.handleBlur}
                title="Email Address (Optional)"
                placeholder="Enter email"
                handleInputChange={this.handleInputChange}
                value={email.value}
                max={100}
                />
                {this.showError(email) ? <ErrMargin>{email.messages[email.valid]}</ErrMargin> : null}
            </Col>
            </Row>
        </MainWrapper>
        );
    }
}
